import React from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/site-data";

export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className="fixed z-[90] bottom-6 right-6 group flex items-center gap-3"
    >
      <span className="hidden md:inline-flex max-w-[260px] items-center gap-2 px-4 py-3 rounded-full bg-black/70 backdrop-blur-xl border border-white/[0.08] text-xs text-zinc-300 shadow-[0_8px_32px_rgba(0,0,0,0.5)] group-hover:border-white/20 transition-all">
        Need Fastest Response? Chat With Us On WhatsApp
      </span>
      <span
        className="relative flex items-center justify-center w-14 h-14 rounded-full"
        style={{
          background: "linear-gradient(180deg,#22c55e,#16a34a)",
          boxShadow:
            "0 10px 30px rgba(34,197,94,0.45), inset 0 1px 0 rgba(255,255,255,0.3)",
        }}
      >
        <span className="absolute inset-0 rounded-full animate-ping bg-green-500/30" />
        <MessageCircle className="w-7 h-7 text-white relative" />
      </span>
    </a>
  );
}
